import { render, staticRenderFns } from "./add.vue?vue&type=template&id=f07e2afc&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f07e2afc')) {
      api.createRecord('f07e2afc', component.options)
    } else {
      api.reload('f07e2afc', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=f07e2afc&", function () {
      api.rerender('f07e2afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/cartridge-type/add.vue"
export default component.exports